__turbopack_context__.v({
  "creditFlowContent": "styles-module-scss-module__vNWf8a__creditFlowContent",
  "creditFlowWrapper": "styles-module-scss-module__vNWf8a__creditFlowWrapper",
  "description": "styles-module-scss-module__vNWf8a__description",
  "flexWithGap": "styles-module-scss-module__vNWf8a__flexWithGap",
});
